<template>
    <div class="overflow-x-auto overflow-y-hidden lg:flex dark:text-white lg:flex-auto justify-center">
        <div v-if="links.length > 3">
            <div class="flex">
                <div class="flex flex-row">
                    <div v-if="showGoTo" class="flex text-center mr-3 place-items-center">
                        <span class="text-md font-medium whitespace-nowrap mr-2 self-center">Go to</span>
                        <select
                            v-if="currentPage"
                            v-model="currentPage.value"
                            class="flex mr-2 block w-full rounded-md border-0 py-1.5 pl-3 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6 max-h-[45px] min-w-[5rem] dark:text-black"
                            @change="pageChange"
                        >
                            <option v-for="link in goTo" :value="link.id">{{ link.id }}</option>
                        </select>
                        <span class="text-md font-medium whitespace-nowrap mr-2 self-center"
                            >of {{ meta.last_page }}</span
                        >
                    </div>
                </div>

                <div class="flex lg:flex-wrap -mb-1">
                    <template v-for="(link, key) in links">
                        <div
                            v-if="link.url === null"
                            :key="key"
                            class="mb-1 mr-1 px-4 py-3 text-gray-400 text-sm leading-4 border rounded"
                            v-html="link.label"
                        />
                        <Link
                            v-else
                            :key="`link-${key}`"
                            class="mb-1 mr-1 px-4 py-3 focus:text-logix-green text-sm leading-4 dark:hover:text-black dark:hover:bg-white border hover:bg-logix-green hover:text-white focus:border-logix-green rounded"
                            :class="{
                                'dark:bg-white dark:text-black bg-logix-green text-white': link.active,
                                'dark:text-black': link.active,
                            }"
                            :href="link.url"
                            v-html="link.label"
                        />
                    </template>
                </div>

                <div class="flex flex-row dark:text-white">
                    <div v-if="showGoTo" class="flex text-center ml-3 place-items-center">
                        <span class="text-md font-medium whitespace-nowrap mr-2 self-center">Per page</span>
                        <select
                            v-model="perPage"
                            class="flex mr-2 block w-full text-black rounded-md border-0 py-1.5 pl-3 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6 max-h-[45px] min-w-[5rem]"
                            @change="perPageChange"
                        >
                            <option v-for="opt in perPageOptions" :value="opt">{{ opt }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { Link } from '@inertiajs/inertia-vue3'
import { Inertia } from '@inertiajs/inertia'
import { useStorage } from '@vueuse/core'

import { reactive, ref, watch } from 'vue'

const props = defineProps({
    links: Array,
    meta: Object,
    topLinks: Object,
    showGoTo: Boolean,
})

const perPage = useStorage('perPage', 15)

const perPageOptions = [15, 45, 90, 180]

const pageChange = (data) => {
    let path = props.topLinks.first.slice(0, props.topLinks.first.lastIndexOf('page=')) + 'page=' + data.target.value
    Inertia.get(path)
}
const perPageChange = (data) => {
    perPage.value = parseInt(data.target.value)

    let path = ''
    if (props.topLinks.first.includes('perPage')) {
        path = props.topLinks.first.slice(0, props.topLinks.first.lastIndexOf('perPage=')) + 'perPage=' + perPage.value
    } else if (props.topLinks.first.includes('?')) {
        path = props.topLinks.first + '&perPage=' + perPage.value
    } else {
        path = props.topLinks.first + '?perPage=' + perPage.value
    }

    Inertia.get(path)
}

const goTo = ref([])

const currentPage = reactive({})

watch(
    () => props.meta,
    (newValue, oldValue) => {
        goTo.value = []
        let page = 1

        if (props.showGoTo && newValue.last_page) {
            while (page <= newValue.last_page) {
                goTo.value.push({
                    id: page,
                    label: page,
                })
                page++
            }
            currentPage.value = _.filter(goTo.value, function (o) {
                return o.id === newValue.current_page
            })[0].id
        }
    },
    { immediate: true, deep: true }
)
</script>
